import * as React from 'react';

function SvgComponent(props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" fill="none" ref={svgRef} {...props}>
      <circle cx={40} cy={40} r={40} fill="#8936B2" />
      <path
        d="M56.336 60h-3.891c0-6.838-5.506-12.398-12.278-12.398S27.891 53.163 27.891 60H24c0-9.075 7.255-16.452 16.169-16.452 8.912 0 16.167 7.377 16.167 16.452zM40.169 42.231c-5.881 0-10.669-4.99-10.669-11.115C29.498 24.987 34.286 20 40.169 20c5.885 0 10.673 4.985 10.673 11.116 0 6.13-4.788 11.115-10.673 11.115zm0-18.178c-3.74 0-6.78 3.168-6.78 7.063 0 3.895 3.04 7.062 6.78 7.062 3.741 0 6.782-3.167 6.782-7.062 0-3.895-3.045-7.063-6.782-7.063z"
        fill="#fff"
      />
    </svg>
  );
}

const PersonDefaultIcon = React.forwardRef(SvgComponent);
export default PersonDefaultIcon;
